/** Stable key so we do not call setState when ReactGrid row model content is unchanged. */
export default function derivedRowsSyncKey(
  rows: { rowId?: string | number; id?: string | number }[] | undefined,
): string {
  if (!rows?.length) {
    return '0';
  }
  return `${rows.length}:${rows.map((row) => row?.rowId ?? row?.id ?? '').join('|')}`;
}
